<template>
  <div
    id="contact_details_section"
    class="flex flex-row gap-2 mx-2 text_color items-center cursor-pointer w-full"
    @click="goToEntityPage"
    :style="{ justifyContent: 'start' }"
  >
    <ProfileIcon :data="contact" :size="28" :font="10" />
    <div class="overflow-x">
      <span class="text-sm break-all">
        {{ contact.name || (contact.first_name && contact.last_name ? `${contact.first_name} ${contact.last_name}` : null) || contact.email }}
      </span>  
    </div>  
  </div>
</template> 
<script setup>
import { defineProps } from "vue";
import { useRouter } from "vue-router";
import ProfileIcon from "@/src/components/ProfileIcon.vue";
import eventBus from "@/src/utils/eventBus.js";

const router = useRouter();

const props = defineProps({
  value: {
    type: Object,
    required: true,
  },
  row: {
    type: Object,
    required: true,
  },
});

const contact = props.value;

let eventTriggered = false;

const goToEntityPage = (event) => {
  event.stopPropagation();
  event.preventDefault();

  if (eventTriggered) {
    return;
  }
  eventTriggered = true;
  setTimeout(() => {
    eventTriggered = false;
  }, 3000);
  const row = props.row;
  const contactIds = row?.message?.contact_ids || [];
  const leadIds = row?.message?.lead_ids || [];

  if (contactIds.length > 0) {
    const route = router.resolve(`/contacts/${contactIds[0]}`);
    window.open(route.href, "_blank", "noopener,noreferrer");
  } else if (leadIds.length > 0) {
    const route = router.resolve(`/leads/${leadIds[0]}`);
    window.open(route.href, "_blank", "noopener,noreferrer");
  } else {
    // contact_ids/lead_ids not stored on message — extract from pixel tracking URL in body
    const messageHtml = row?.message?.message || "";
    const pixelMatch = messageHtml.match(/pixel\?([^'">\s]+)/);
    if (pixelMatch) {
      const params = new URLSearchParams(pixelMatch[1]);
      const cid = params.get("cid");
      const lid = params.get("lid");
      if (cid) {
        const route = router.resolve(`/contacts/${cid}`);
        window.open(route.href, "_blank", "noopener,noreferrer");
        return;
      } else if (lid) {
        const route = router.resolve(`/leads/${lid}`);
        window.open(route.href, "_blank", "noopener,noreferrer");
        return;
      }
    }
    eventBus.emit("emails/goToEntity", {
      email: contact.email,
    });
  }
};
</script>